import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { CartCouponModule } from '@spartacus/cart/base/components';
import { CmsConfig, ConfigModule, FeaturesConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule, PromotionsModule } from '@spartacus/storefront';
import { effectsRealtimeStock } from '../../../../../custom/cart/realtime-stock/store/effects/custom-realtime-stock.effect';
import { CustomUnavailableProductsModule } from '../../../../../custom/cms-components/content/custom-unavailable-products/custom-unavailable-products.module';
import { CustomIconsModule } from '../../../../../custom/icons/custom-icons.module';
import { CustomStockNotificationModule } from '../../product/custom-stock-notification/custom-stock-notification.module';
import { CustomAddToWishListModule } from '../custom-add-to-whish-list/custom-add-to-wish-list.module';
import { CustomCartCouponModule } from '../custom-cart-coupon/custom-cart-coupon.module';
import { CustomCartSharedModule } from '../custom-cart-shared/custom-cart-shared.module';
import { CustomCartDetailsComponent } from './custom-cart-details.component';

@NgModule({
  declarations: [CustomCartDetailsComponent],
  imports: [
    CommonModule,
    CartCouponModule,
    RouterModule,
    UrlModule,
    PromotionsModule,
    FeaturesConfigModule,
    CustomCartSharedModule,
    IconModule,
    CustomIconsModule,
    CustomCartCouponModule,
    I18nModule,
    MediaModule,
    CustomStockNotificationModule,
    CustomAddToWishListModule,
    CustomUnavailableProductsModule,
    EffectsModule.forFeature(effectsRealtimeStock),
    ConfigModule.withConfig({
      cmsComponents: {
        CartComponent: {
          component: CustomCartDetailsComponent,
        },
      }
    } as CmsConfig),
  ]
})
export class CustomCartDetailsModule {
}
